import { render, staticRenderFns } from "./TheHistory.vue?vue&type=template&id=2f422fc6&"
import script from "./TheHistory.vue?vue&type=script&lang=js&"
export * from "./TheHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports